<div class="border-b-2 border-primary-600" style="border-color: var(--color-primary-600);"></div>
<div class="footer-layout-sec">
    <p class="text-text">{{appName}} v{{ver}}</p>
</div>